module.exports = __webpack_public_path__ + "static/media/electric-cable.d17b506d.png";